import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import axiosInstance from '../../api/axiosInstance';
import { apiurl, formatMoney } from '../../App';
import dateFormat from 'dateformat';
import {
  HiOutlineX,
  HiOutlineCheckCircle,
  HiOutlineRefresh,
  HiOutlineDocumentDownload,
  HiOutlineUser,
  HiOutlinePhone,
  HiOutlineCalendar,
  HiOutlineCollection,
  HiOutlineCash,
  HiOutlineClock,
  HiOutlineTruck,
  HiOutlineBadgeCheck,
} from 'react-icons/hi';

const STATUS_STEPS = [
  { id: 1, label: 'Quote Sent / Pending', code: 'quote_sent', statusName: 'Pending Approval' },
  { id: 2, label: 'Approved', code: 'approved', statusName: 'Approved' },
  { id: 5, label: 'Packed', code: 'packed', statusName: 'Packed' },
  { id: 8, label: 'Delivered / Completed', code: 'delivered', statusName: 'Delivered' },
];

class PrescriptionDetailView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      props_loading: false,
      updating: false,
      orderData: {},
      medicines: [],
      statusHistory: [],
      currentStatusId: 1,
    };
  }

  componentDidMount() {
    this.initData();
    this.fetchStatusHistory();
  }

  initData = () => {
    const raw = this.props.prescriptionEntryData?.[0] || {};
    let parsedMedicines = [];

    if (raw.p_medicinedetails || raw.medicines) {
      try {
        const source = raw.p_medicinedetails || raw.medicines;
        const list = typeof source === 'string' ? JSON.parse(source) : source;
        if (Array.isArray(list)) {
          parsedMedicines = list.map((item, idx) => {
            const days = Number(item.days) || 1;
            const counts = Array.isArray(item.counts) && item.counts.length >= 4
              ? item.counts
              : [
                  Number(item.morning) || 0,
                  Number(item.afternoon) || 0,
                  Number(item.evening) || 0,
                  Number(item.night) || 0,
                ];
            const dailyCount = counts.reduce((a, b) => a + (Number(b) || 0), 0) || 1;
            const totalQuantity = Number(item.totalmedicine) || Number(item.quantity) || (days * dailyCount);
            const unitRate = parseFloat(item.per_tablet_price) || parseFloat(item.unit_rate) || parseFloat(item.unitRate) || 0;
            const linePrice = parseFloat(item.price) || parseFloat(item.amount) || (unitRate * totalQuantity);

            return {
              id: item.id || idx + 1,
              name: item.name || item.medicine_name || `Medicine #${idx + 1}`,
              dosage: item.dosage || '',
              counts: counts,
              days: days,
              foodtype: item.foodtype !== undefined ? item.foodtype : 0,
              quantity: totalQuantity,
              unitRate: unitRate,
              amount: linePrice,
              instruction: item.instruction || '',
            };
          });
        }
      } catch (e) {
        console.error('Error parsing medicines in PrescriptionDetailView:', e);
      }
    }

    let statusId = 1;
    if (raw.status_id) {
      statusId = Number(raw.status_id);
    } else if (raw.status === 'Delivered' || raw.status === 'Completed') {
      statusId = 8;
    } else if (raw.status === 'Packed') {
      statusId = 5;
    } else if (raw.status === 'Approved') {
      statusId = 2;
    }

    this.setState({
      orderData: raw,
      medicines: parsedMedicines,
      currentStatusId: statusId,
    });
  };

  fetchStatusHistory = async () => {
    const raw = this.props.prescriptionEntryData?.[0] || {};
    const orderId = raw.order_id || raw.id || 0;
    if (!orderId) return;

    try {
      const response = await axiosInstance.post(
        apiurl + 'pharmacy/viewOrderStatus',
        { order_id: orderId }
      );

      if (response && response.data && Array.isArray(response.data.data)) {
        const history = response.data.data;
        const maxStatus = history.reduce(
          (max, item) => (item.status_id > max ? item.status_id : max),
          this.state.currentStatusId
        );
        this.setState({
          statusHistory: history,
          currentStatusId: maxStatus,
        });
      }
    } catch (e) {
      console.error('fetchStatusHistory error:', e);
    }
  };

  handleUpdateStatus = async (targetStatusId, isDirectWalkin = false) => {
    const { orderData } = this.state;
    const orderId = orderData.order_id || orderData.id || 0;
    if (!orderId) {
      alert('Order ID is missing');
      return;
    }

    this.setState({ updating: true });

    try {
      const payload = {
        order_id: orderId,
        status_id: targetStatusId,
        payment_status: isDirectWalkin || targetStatusId === 8 ? 1 : 0,
        is_walkin: isDirectWalkin ? 1 : 0,
      };

      await axiosInstance.post(
        apiurl + 'pharmacy/updateOrderStatus',
        payload
      );

      this.setState({ updating: false, currentStatusId: targetStatusId });

      if (this.props.handleopenSuccess) {
        this.props.handleopenSuccess(
          isDirectWalkin
            ? 'Walk-in prescription marked as Paid & Dispensed!'
            : `Order status updated to ${this.getStatusLabel(targetStatusId)}!`,
          true
        );
      }

      if (this.props.getTableData) {
        this.props.getTableData();
      }

      this.fetchStatusHistory();

      if (isDirectWalkin) {
        setTimeout(() => {
          if (this.props.onClose) this.props.onClose();
        }, 800);
      }
    } catch (err) {
      console.error('handleUpdateStatus error:', err);
      this.setState({ updating: false });
      if (this.props.handleopenSuccess) {
        this.props.handleopenSuccess('Failed to update status. Please try again.', false);
      }
    }
  };

  getStatusLabel = (id) => {
    switch (id) {
      case 1:
        return 'Pending Approval';
      case 2:
        return 'Approved';
      case 3:
      case 5:
        return 'Packed';
      case 6:
      case 7:
        return 'Out for Delivery';
      case 8:
        return 'Delivered';
      default:
        return 'In Progress';
    }
  };

  getNextStatusId = (currentId) => {
    if (currentId < 2) return 2;
    if (currentId < 5) return 5;
    if (currentId < 8) return 8;
    return 8;
  };

  render() {
    const { prescriptionopenview, onClose } = this.props;
    const { orderData, medicines, currentStatusId, updating } = this.state;
    const isCompleted = currentStatusId >= 8;
    const nextStatusId = this.getNextStatusId(currentStatusId);

    const timingLabels = ['Morn', 'Noon', 'Eve', 'Night'];

    return (
      <Dialog
        open={Boolean(prescriptionopenview)}
        onClose={onClose}
        fullWidth
        maxWidth='md'
        PaperProps={{
          style: {
            borderRadius: '28px',
            padding: '0',
            overflow: 'hidden',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          },
        }}
      >
        <div className='bg-white flex flex-col max-h-[90vh]'>
          {/* Header */}
          <div className='p-6 bg-slate-900 text-white flex items-center justify-between gap-4 shrink-0'>
            <div className='flex items-center gap-3.5'>
              <div className='w-12 h-12 rounded-2xl bg-teal-500/20 border border-teal-500/30 text-teal-400 flex items-center justify-center'>
                <HiOutlineCollection size={24} />
              </div>
              <div>
                <div className='flex items-center gap-2.5'>
                  <h2 className='text-xl sm:text-2xl font-black text-white tracking-tight'>
                    Prescription & Order Status
                  </h2>
                  <span className='px-3 py-0.5 rounded-full bg-white/10 text-teal-300 font-mono text-xs font-bold border border-white/10'>
                    #{orderData.custom_order_id || orderData.orderId || orderData.prescription_id}
                  </span>
                </div>
                <p className='text-xs text-slate-400 font-medium mt-0.5'>
                  Track delivery progress, update order status, and bill walk-in patients
                </p>
              </div>
            </div>

            <button
              type='button'
              onClick={onClose}
              className='w-10 h-10 rounded-xl bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-all cursor-pointer'
            >
              <HiOutlineX size={20} />
            </button>
          </div>

          {/* Scrollable Content */}
          <div className='p-6 space-y-6 overflow-y-auto custom-scrollbar flex-1'>
            {/* Patient & Prescribing Doctor Summary Card */}
            <div className='p-5 rounded-2xl bg-slate-50 border border-slate-100 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4'>
              <div>
                <p className='text-xs font-black uppercase tracking-wider text-slate-400'>Patient Name</p>
                <p className='text-base font-black text-slate-900 mt-0.5'>
                  {orderData.customer || 'Walk-in Patient'}
                </p>
                <p className='text-xs text-slate-500 font-medium'>
                  {orderData.gender || '-'} {orderData.age ? `• ${orderData.age} yrs` : ''}
                </p>
              </div>

              <div>
                <p className='text-xs font-black uppercase tracking-wider text-slate-400'>Phone Number</p>
                <p className='text-sm font-bold text-slate-800 font-mono mt-0.5'>
                  {orderData.customer_phno || orderData.phone_no || '-'}
                </p>
              </div>

              <div>
                <p className='text-xs font-black uppercase tracking-wider text-slate-400'>Prescribed By</p>
                <p className='text-sm font-bold text-teal-700 mt-0.5'>
                  {orderData.doctor_name || orderData.doctorName ? `Dr. ${orderData.doctor_name || orderData.doctorName}` : 'Direct Entry'}
                </p>
                <p className='text-xs text-slate-400'>
                  {dateFormat(orderData.prescript_date || new Date(), 'dd-mmm-yyyy')}
                </p>
              </div>

              <div>
                <p className='text-xs font-black uppercase tracking-wider text-slate-400'>Total Billed</p>
                <p className='text-lg font-black text-teal-800 mt-0.5'>
                  {formatMoney(orderData.total_amount || 0)} <span className='text-xs text-teal-600 font-bold'>₹</span>
                </p>
                <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-bold ${
                  orderData.payment_status === 1 || isCompleted
                    ? 'bg-emerald-100 text-emerald-800'
                    : 'bg-amber-100 text-amber-800'
                }`}>
                  {orderData.payment_status === 1 || isCompleted ? 'Paid / Collected' : 'Payment Pending'}
                </span>
              </div>
            </div>

            {/* Status Progress Stepper */}
            <div className='p-5 rounded-2xl bg-white border border-gray-200 shadow-2xs space-y-3'>
              <div className='flex items-center justify-between'>
                <p className='text-xs font-black uppercase tracking-wider text-gray-500'>
                  Order Status Progression
                </p>
                <span className='px-3 py-1 rounded-full text-xs font-bold bg-teal-50 text-teal-700 border border-teal-200'>
                  Current: {this.getStatusLabel(currentStatusId)}
                </span>
              </div>

              <div className='grid grid-cols-2 sm:grid-cols-4 gap-2 pt-2'>
                {STATUS_STEPS.map((step) => {
                  const isDone = currentStatusId >= step.id;
                  const isCurrent = (step.id === 1 && currentStatusId < 2) ||
                    (step.id === 2 && currentStatusId >= 2 && currentStatusId < 5) ||
                    (step.id === 5 && currentStatusId >= 5 && currentStatusId < 8) ||
                    (step.id === 8 && currentStatusId >= 8);

                  return (
                    <div
                      key={step.id}
                      className={`p-3 rounded-xl border text-center transition-all ${
                        isCurrent
                          ? 'bg-teal-50 border-teal-500 text-teal-900 shadow-xs ring-2 ring-teal-500/20'
                          : isDone
                          ? 'bg-slate-50 border-slate-200 text-slate-700'
                          : 'bg-gray-50/50 border-gray-200/60 text-gray-400 opacity-60'
                      }`}
                    >
                      <div className='flex items-center justify-center gap-1.5 mb-1'>
                        {isDone ? (
                          <HiOutlineCheckCircle className='text-teal-600' size={16} />
                        ) : (
                          <span className='w-4 h-4 rounded-full border border-gray-300 inline-block' />
                        )}
                        <span className='text-xs font-bold'>{step.label}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Prescribed Medicines List */}
            <div className='space-y-3'>
              <div className='flex items-center justify-between'>
                <h3 className='text-sm font-black uppercase tracking-wider text-gray-700'>
                  Prescribed Medicines ({medicines.length})
                </h3>
              </div>

              {medicines.length === 0 ? (
                <div className='p-6 rounded-2xl bg-gray-50 border border-gray-200 text-center text-sm text-gray-500'>
                  No medicine details recorded for this prescription.
                </div>
              ) : (
                <div className='border border-gray-200 rounded-2xl overflow-hidden shadow-2xs'>
                  <table className='w-full text-left text-xs'>
                    <thead className='bg-slate-50 border-b border-gray-200 text-slate-500 font-bold uppercase tracking-wider'>
                      <tr>
                        <th className='py-3 px-4 text-center'>#</th>
                        <th className='py-3 px-4'>Medicine</th>
                        <th className='py-3 px-3 text-center'>Schedule</th>
                        <th className='py-3 px-3 text-center'>Days</th>
                        <th className='py-3 px-3 text-center'>Qty</th>
                        <th className='py-3 px-3 text-right'>Unit Rate</th>
                        <th className='py-3 px-4 text-right'>Amount</th>
                      </tr>
                    </thead>
                    <tbody className='divide-y divide-gray-100'>
                      {medicines.map((m, idx) => (
                        <tr key={idx} className='hover:bg-slate-50/50'>
                          <td className='py-3 px-4 text-center font-bold text-gray-400'>{idx + 1}</td>
                          <td className='py-3 px-4'>
                            <span className='font-bold text-gray-900 block'>{m.name}</span>
                            {m.instruction && (
                              <span className='text-xs text-gray-500 italic block mt-0.5'>
                                {m.instruction}
                              </span>
                            )}
                          </td>
                          <td className='py-3 px-3 text-center'>
                            <div className='inline-flex gap-1'>
                              {timingLabels.map((time, tIdx) => (
                                <span
                                  key={tIdx}
                                  className={`px-1.5 py-0.5 rounded text-xs font-bold ${
                                    m.counts?.[tIdx]
                                      ? 'bg-teal-100 text-teal-800'
                                      : 'bg-gray-100 text-gray-400'
                                  }`}
                                >
                                  {time}
                                </span>
                              ))}
                            </div>
                          </td>
                          <td className='py-3 px-3 text-center font-bold text-gray-700'>{m.days}</td>
                          <td className='py-3 px-3 text-center font-bold text-gray-900'>{m.quantity}</td>
                          <td className='py-3 px-3 text-right font-mono font-bold text-gray-700'>
                            {formatMoney(m.unitRate)}
                          </td>
                          <td className='py-3 px-4 text-right font-mono font-black text-teal-800'>
                            {formatMoney(m.amount)} ₹
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

          {/* Action Footer */}
          <div className='p-5 bg-slate-50 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-3 shrink-0'>
            <button
              type='button'
              onClick={onClose}
              className='w-full sm:w-auto px-6 py-2.5 rounded-xl bg-white border border-gray-200 hover:bg-gray-100 text-slate-700 text-sm font-bold transition-all cursor-pointer'
            >
              Close
            </button>

            <div className='flex flex-wrap items-center gap-2.5 w-full sm:w-auto justify-end'>
              {!isCompleted && (
                <>
                  <button
                    type='button'
                    disabled={updating}
                    onClick={() => this.handleUpdateStatus(nextStatusId, false)}
                    className='flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-bold rounded-xl transition-all shadow-xs active:scale-95 cursor-pointer disabled:opacity-50'
                  >
                    <HiOutlineRefresh size={18} />
                    <span>Advance to: {this.getStatusLabel(nextStatusId)}</span>
                  </button>

                  <button
                    type='button'
                    disabled={updating}
                    onClick={() => this.handleUpdateStatus(8, true)}
                    className='flex items-center gap-2 px-6 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-black rounded-xl transition-all shadow-md shadow-emerald-600/20 active:scale-95 cursor-pointer disabled:opacity-50'
                    title='Mark order as paid and dispensed immediately for walk-in patient'
                  >
                    <HiOutlineCheckCircle size={18} />
                    <span>Mark as Paid & Delivered (Walk-in)</span>
                  </button>
                </>
              )}

              {isCompleted && (
                <span className='flex items-center gap-1.5 px-4 py-2 rounded-xl bg-emerald-50 text-emerald-800 font-bold text-sm border border-emerald-200'>
                  <HiOutlineBadgeCheck size={20} />
                  <span>Order Fully Completed & Dispensed</span>
                </span>
              )}
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}

export default PrescriptionDetailView;
